import { defineStore } from 'pinia';
import { useIndexStore } from './IndexStore';
import HotelManagementService from '@/service/HotelManagementService';

export const useHotelManagementStore = defineStore('hotelManagementStore', {
  state: () => ({
    hotels: [],
    isLoading: false
  }),
  getters: {
    doLoading: (state) => state.isLoading,
    getUrlUploadFile: () => {
      const Service = new HotelManagementService();
      return Service.getUrlPreview();
    }
  },

  actions: {
    async getListHotel() {
      const Service = new HotelManagementService();
      const res = await Service.getListHotel();
      this.hotels = res?.data;
      return res?.data;
    },
    async updateHotelStatus(code, payload, type) {
      const Service = new HotelManagementService();
      try {
        const res = await Service.updateHotelStatus(code, payload, type);
        if (res) {
          return res?.data;
        }
      } catch (e) {
        const store = useIndexStore();
        store.updateNotification(e);
      }
    },
    async syncData() {
      const Service = new HotelManagementService();
      try {
        this.isLoading = true;
        const res = await Service.syncData();
        if (res) {
          this.isLoading = false;
          return res?.data;
        }
      } catch (e) {
        this.isLoading = false;
        const store = useIndexStore();
        store.updateNotification(e);
      }
    },
    updateHotelData(code, payload) {
      const Service = new HotelManagementService();
      return Service.updateHotelData(code, payload);
    },
    getFileJson() {
      const Service = new HotelManagementService();
      return Service.getFileJson();
    },
    updateFileJson(payload) {
      const Service = new HotelManagementService();
      return Service.updateFileJson(payload);
    },
    getAvgPaxRoom() {
      const Service = new HotelManagementService();
      return Service.getAvgPaxRoom();
    },
    updateAvgPaxRoom(payload) {
      const Service = new HotelManagementService();
      return Service.updateAvgPaxRoom(payload);
    },
    excludeHotelRoom(id, payload) {
      const Service = new HotelManagementService();
      return Service.excludeHotelRoom(id, payload);
    },
    updateTypeCallRoom(id, option) {
      const Service = new HotelManagementService();
      return Service.updateTypeCallRoom(id, option);
    },
    getPricingQuote(id, body) {
      const Service = new HotelManagementService();
      return Service.getPricingQuote(id, body);
    },
    getHcmsPromotion(id, body) {
      const Service = new HotelManagementService();
      return Service.getHcmsPromotion(id, body);
    },
    getHotelInfo(ttsCode) {
      const Service = new HotelManagementService();
      return Service.getHotelInfo(ttsCode);
    },

    addNewHotel(payload) {
      const Service = new HotelManagementService();
      return Service.addNewHotel(payload);
    },

    deleteHotel(id) {
      const Service = new HotelManagementService();
      return Service.deleteHotel(id);
    },

    importFileHotel(payload) {
      const Service = new HotelManagementService();
      return Service.importFileHotel(payload);
    },

    getVersionRevert(type) {
      const Service = new HotelManagementService();
      return Service.getVersionRevert(type);
    },

    getPreviewByFileName(fileName, type) {
      const Service = new HotelManagementService();
      return Service.getPreviewByFileName(fileName, type);
    },

    revertVersion(payload) {
      const Service = new HotelManagementService();
      return Service.revertVersion(payload);
    }
  }
});
